import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import {
  ContactsContainerStyled,
  ContactsListListed,
  ContactsStyled,
  FontAwesomeIconStyled,
  InfoContainer,
  TypographyStyled,
} from './ContactsBancoValor.styles';
import { SocialNetworksBancoValor } from './SocialNetworks';

export const ContactsBancoValor = () => {
  const email = TrlFormattedMessagePlain({ id: 'TRLT_UI-EMAIL_BVALOR' });
  const site = TrlFormattedMessagePlain({ id: 'TRLT_UI-SITE_BVALOR' });

  return (
    <ContactsContainerStyled>
      <Box>
        <ContactsStyled>
          <FormattedMessage id="TRLT_UI-CONTACTS" />
        </ContactsStyled>

        <ContactsListListed>
          <InfoContainer>
            <FontAwesomeIconStyled icon={faPhone} />
            <TypographyStyled id="bfacmPhoneNumber">
              <FormattedMessage id="TRLT_UI-PHONE_NUMBER_BVALOR" />
            </TypographyStyled>
          </InfoContainer>
          <InfoContainer>
            <FontAwesomeIconStyled icon={faLocationDot} />
            <TypographyStyled>
              <FormattedMessage id="TRLT_UI-ADRESSE_BVALOR" />
            </TypographyStyled>
          </InfoContainer>
          <InfoContainer component="a" href={`mailto:${email}`}>
            <FontAwesomeIconStyled icon={faEnvelope} />
            <TypographyStyled>{email}</TypographyStyled>
          </InfoContainer>
          <InfoContainer component="a" href={`https://${site}`} target="_blank">
            <FontAwesomeIconStyled icon={faGlobe} />
            <TypographyStyled>{site}</TypographyStyled>
          </InfoContainer>
        </ContactsListListed>
      </Box>
      <SocialNetworksBancoValor />
    </ContactsContainerStyled>
  );
};
